import { serializable, alias, primitive } from 'serializr';

export class LocationRevenue {
    @serializable(alias('revenue', primitive()))
    revenue?: number;

    @serializable(alias('revenue_unit', primitive()))
    revenueUnit?: string; // 'CAD' | 'USD' | 'EUR'

    @serializable(alias('revenue_status', primitive()))
    revenueStatus?: boolean;

    @serializable(alias('year', primitive()))
    year?: number;
}

